export enum ColActionId {
  archive = 'archive',
  cancelArchived = 'cancelArchived',
  copy = 'copy',
  delete = 'delete',
  cancelDelete = 'cancelDelete',
  disable = 'disable',
  downloadPdf = 'downloadPdf',
  download = 'download',
  edit = 'edit',
  enable = 'enable',
  move = 'move',
  obsolete = 'obsolete',
  open = 'open',
  close = 'close',
  openNewTab = 'openNewTab',
  openParent = 'openParent',
  publish = 'publish',
  duplicate = 'duplicate',
  duplicateForTest = 'duplicateForTest',
  duplicateAsResponsible = 'duplicateAsResponsible',
  reopen = 'reopen',
  rename = 'rename',
  separator = 'separator',
  select = 'select',
  showDetail = 'showDetail',
  unlockUserAccess = 'unlockUserAccess',
  validate = 'validate',
  snapshot = 'snapshot',
  visitCustomerDomain = 'visitCustomerDomain',
  increasePriority = 'increasePriority',
  decreasePriority = 'decreasePriority',
  editPriority = 'editPriority',
  permission = 'permission',
  manage = 'manage',
}
